import { Component } from '@angular/core';
import { FaqAccordion } from '../../../core/models/learn/faq-accordion';
import { HowItWorksFaqLd, ldToList } from '../../../../assets/static/json-ld';

@Component({
    selector: 'app-how-it-works',
    templateUrl: './how-it-works.component.html',
    styleUrls: ['./how-it-works.component.scss'],
    standalone: false
})
export class HowItWorksComponent {
  faqList: Array<{ question: string; answer: string }> = [];
  HowItWorksFaqLd = HowItWorksFaqLd;
  pageFaqs: FaqAccordion[] = ldToList(HowItWorksFaqLd);
}
